/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".width-70[_ngcontent-%COMP%]{width:95%}.display-grid[_ngcontent-%COMP%]{display:grid;grid-template-columns:70% 30%}"];
export { styles as styles };
